<div>
    <div class="box">
      <div class="drag-handle" cdkDragHandle>
        <button (click)="onClickIntersect()" class="circle-infobox-button" id="streetInfoTool" matTooltip="Activar herramienta street view" matTooltipPosition="above">
            <div class="button-icon">
              <img *ngIf="this.toolInfoBoxService.isInfoBoxActive" [src]="'icon_info_box.svg' | findUrl" class="img-button">
              <img *ngIf="!this.toolInfoBoxService.isInfoBoxActive" [src]="'icon_info_box_gris.svg' | findUrl" class="img-button">
            </div>
        </button>
      </div>
    </div>
</div>